import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Button, message } from "antd";
import { UnlockOutlined } from "@ant-design/icons";
import { useGenericMutation } from "../../../queries/use-generic-mutation";
import sidebarImage from "../../../assets/login-sidebar.webp";
import { showUserNotification } from "../../../utils/functions";
import SOURCES from "../../../utils/constants";
import CommonForm from "../../global/form";
import Spinner from "../../global/spinner";

const EnhancedForgotPassword = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [form] = Form.useForm();

    const forgetPasswordMutation = useGenericMutation({
        endpoint: `/user/forgot-password-challenge`,
    });

    const handleFinish = async (values) => {
        try {
            await forgetPasswordMutation.mutateAsync({ email: values.email });
            setTimeout(() => {
                history.push("/verifypassword?email=" + values.email);
            }, 2000);
        } catch (err) {
            console.log(err)
        }
    };

    const formData = [
        {
            label: "Email",
            name: "email",
            type: "email",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            required: true,
            placeholder: "Enter your registered email",
            span: 24,
            message: "Email is required",
        },
    ];

    return (
        <div className="flex min-h-screen">
            {/* Left Side - Image & Slogan */}
            <div className="hidden lg:flex w-1/2 relative bg-gray-900 items-center justify-center overflow-hidden">
                <img
                    src={sidebarImage}
                    alt="Background"
                    className="absolute inset-0 w-full h-full object-cover"
                />

                {/* Logo on Sidebar */}
                <div className="absolute top-8 left-8 z-30">
                    <h1 className="text-4xl font-bold tracking-tighter m-0">
                        <span className="text-primary">Leads</span>
                        <span className="text-white">Import</span>
                    </h1>
                </div>
            </div>

            {/* Right Side - Forgot Password Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center bg-white p-8 lg:p-16 overflow-y-auto max-h-screen">
                <div className="w-full max-w-md space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
                    <div className="text-center">
                        <h2 className="text-3xl font-bold text-gray-900">Forgot Password</h2>
                        <p className="mt-2 text-gray-500">Enter your email to recover your password</p>
                    </div>

                    <div className="bg-white">
                        <CommonForm
                            form={form}
                            data={formData}
                            onFinish={handleFinish}
                            isInternalSubmitt={false}
                        />

                        <Button
                            type="primary"
                            onClick={() => form.submit()}
                            className="w-full h-12 text-base font-bold rounded-xl shadow-lg shadow-primary/25 !bg-primary hover:!bg-primary/90 border-none mt-4 flex items-center justify-center gap-2"
                        >
                            {forgetPasswordMutation.isPending && <Spinner className="!border-white" />}
                            {!forgetPasswordMutation.isPending && <UnlockOutlined className="text-lg" />}
                            Recover Password
                        </Button>

                        <p className="text-center mt-8 text-gray-600">
                            Remember your password?{" "}
                            <Link to="/" className="font-bold text-primary hover:text-primary/80">
                                Go to Sign In
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnhancedForgotPassword;
